import { cn } from '@/shared/utilities';
import { Card, type CardProps, type SxProps, type Theme } from '@mui/material';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface MessageContentProps {
  children: React.ReactNode;
  isOwn?: boolean;
  className?: string;
  variant?: CardProps['variant'];
  onContextMenu: (e: React.MouseEvent) => void;
  sxOverrides?: SxProps<Theme>;
}

const MessageContent = memo<MessageContentProps>(
  ({ children, isOwn = false, className, variant = 'outlined', onContextMenu, sxOverrides }) => {
    const { t } = useTranslation();
    // Memoize sx props to avoid object recreation on every render
    const cardSx = useMemo(
      () => ({
        backgroundColor: isOwn ? 'primary.lighter' : 'background.paper',
        opacity: isOwn ? 0.8 : 1,
        borderRadius: '16px',
        color: 'text.primary',
        borderColor: 'primary.lighter',
        ...sxOverrides
      }),
      [isOwn, sxOverrides]
    );

    return (
      <Card
        variant={variant}
        elevation={2}
        className={cn(isOwn ? 'mex:ml-auto' : 'mex:mr-auto', className)}
        sx={cardSx}
        onContextMenu={onContextMenu}
        aria-label={t('messages.layout.messageContent')}
      >
        {children}
      </Card>
    );
  }
);

export { MessageContent };
